exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".map-view[data-v-9d4f2a94] {\n  display: flex;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 1112px;\n  min-height: 75vh;\n  max-height: 700px;\n  height: 90vh;\n}\n.reduced-height .map-view[data-v-9d4f2a94] {\n  min-height: 400px;\n  max-height: 600px;\n  height: 55vh;\n}\n[data-v-9d4f2a94] button:focus {\n  outline: none;\n}\n", ""]);

// exports
